export default "__VITE_ASSET__aac374b7__"